enum INFO {
  MISSING_API = 'MISSING_API',
  MISSING_OPERATION_NAME = 'MISSING_OPERATION_NAME',
  NOT_AUTHORIZE = 'NOT_AUTHORIZE',
}

export { INFO };
export default {};
